import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import napihamiLogo from "@/assets/napihami_logo.png";
import { AccessDeniedPopup } from "./AccessDeniedPopup";

interface AdminOnlyGuardProps {
  children: React.ReactNode;
}

export const AdminOnlyGuard = ({ children }: AdminOnlyGuardProps) => {
  const navigate = useNavigate();
  const { role, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (role !== "admin") {
        // Don't auto-redirect, show popup instead
      }
    }
  }, [role, loading, navigate]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <img 
          src={napihamiLogo} 
          alt="NapiHami" 
          className="h-[150px] w-auto animate-slide-down"
        />
      </div>
    );
  }

  if (role !== "admin") {
    return <AccessDeniedPopup redirectTo="/admin" redirectLabel="Vissza a Dashboard-ra" />;
  }

  return <>{children}</>;
};
